interface BadgeProps {
  variant: 'success' | 'warning' | 'error' | 'info' | 'neutral';
  children: React.ReactNode;
  dot?: boolean;
  pulse?: boolean;
}

const variantStyles: Record<BadgeProps['variant'], string> = {
  success: 'bg-emerald-50 border-emerald-100/50 text-emerald-700',
  warning: 'bg-amber-50 border-amber-100 text-amber-700',
  error: 'bg-red-50 border-red-100 text-red-700',
  info: 'bg-blue-50 border-blue-100 text-blue-700',
  neutral: 'bg-slate-100 border-slate-200 text-slate-600',
};

const dotStyles: Record<BadgeProps['variant'], string> = {
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  error: 'bg-red-500',
  info: 'bg-blue-500',
  neutral: 'bg-slate-400',
};

export default function Badge({ variant, children, dot = true, pulse = false }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${variantStyles[variant]}`}
    >
      {dot && (
        <span className={`size-1.5 rounded-full ${dotStyles[variant]} ${pulse ? 'animate-pulse' : ''}`} />
      )}
      {children}
    </span>
  );
}
